import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ChallengeOobSelectDeviceData, DeviceInformationData, OobSelectDeviceEvent } from './oob-select-device.model';
import { ChallengeError } from '@backbase/identity-core-ang';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IdGeneratorService } from '../../../id-generator/id-generator.service';

@Component({
  selector: 'bb-transaction-signing-oob-select-device',
  templateUrl: 'oob-select-device.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [IdGeneratorService],
})
export class TransactionSigningOobSelectDeviceComponent {
  @Output() cancel = new EventEmitter<void>();
  @Output() acceptError = new EventEmitter<Error>();
  /* tslint:disable-next-line */
  @Output() complete = new EventEmitter<OobSelectDeviceEvent>();

  @Input()
  set data(value: ChallengeOobSelectDeviceData) {
    this.challengeData = value;
  }

  get data(): ChallengeOobSelectDeviceData | never {
    if (!this.challengeData) {
      throw new Error('No challenge data set');
    }
    return this.challengeData;
  }

  @Input() error: ChallengeError | undefined;

  readonly form: FormGroup = this.formBuilder.group({
    device: [undefined, Validators.required],
  });

  challengeData: ChallengeOobSelectDeviceData | undefined;
  showErrors = false;
  ids = {
    'select-device-control': this.idGeneratorService.generateId('select-device-control'),
  };

  constructor(private readonly formBuilder: FormBuilder, private readonly idGeneratorService: IdGeneratorService) {}

  onComplete(): void {
    this.showErrors = true;
    if (this.form.invalid) {
      return;
    }

    const { deviceId } = this.form.controls.device.value;
    this.complete.emit({ deviceId } as OobSelectDeviceEvent);
  }

  onCancel(): void {
    this.cancel.emit();
  }

  deviceHasFriendlyName(device: DeviceInformationData): boolean {
    return typeof device.friendlyName === 'string';
  }

  deviceGetVendorModelName(device: DeviceInformationData): string | boolean {
    return device.vendor && device.model ? `${device.vendor} ${device.model}` : false;
  }

  get showDeviceNotChosenError(): boolean {
    return !this.form.value.device;
  }
}
